import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn("apily-skeleton rounded-md", className)}
      aria-hidden="true"
      {...props} />
  );
}

export { Skeleton }
